import { DEFAULT_DATE } from '../utilities/constants';
import { client, gql } from './Client';

const siteDisciplineListQuery = gql`
  query inspectorSiteScheduleSummary($lastRequested: DateTime!) {
    inspectorSiteScheduleSummary(lastRequested: $lastRequested) {
      siteId
      siteName
      inspectorId
      clerkId
      dateModified
      disciplines {
        disciplineId
        disciplineName
        totalSchedules
      }
    }
  }
`;

const siteDisciplineList = () =>
  client.query({ query: siteDisciplineListQuery, variables: { lastRequested: DEFAULT_DATE } });

export { siteDisciplineList };
